import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { LogginInterceptor } from "./loggin.interceptor";

// list all interceptors here
export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: LogginInterceptor, multi: true },
]